<form [formGroup]="detailsForm">
    <app-form-section>
        <div class="box">
            <div class="header">
                <span class="material-symbols-rounded trailing" aria-hidden="true"> contract </span>
                <h5 style="margin-bottom: 3.2rem">{{ 'FEATURES.AGREEMENTS.TYPE' | translate }}</h5>
            </div>
            <div class="form">
                <app-form-row>
                    <app-form-group>
                        <app-dropdown [items]="agreementTypes$ | async" formControlName="agreementTypeId" />
                        <app-validation-message
                            *ngIf="showPotentialValidationMessages"
                            [control]="typeForm.agreementTypeId"
                            languageKey="FEATURES.AGREEMENTS.TYPE"
                        />
                    </app-form-group>
                    <app-form-group></app-form-group>
                </app-form-row>
            </div>
        </div>
    </app-form-section>
</form>
